// extracted by mini-css-extract-plugin
module.exports = {"productSplash":"ProductSplash_productSplash____U21"};